/**
 * @generated SignedSource<<237af970bbda938e90272202719f5aea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type StartWhen = "ITEM_ADDED" | "ITEM_DELETED" | "ITEM_UPDATED" | "NO_START" | "%future added value";
export type Status = "ACTIVE" | "ARCHIVED" | "DRAFT" | "INACTIVE" | "TEMPLATE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type processDefinitionsArchivedQueryFragment$data = {
  readonly content: ReadonlyArray<{
    readonly createdAt: any;
    readonly definitionKey: string;
    readonly definitionName: string;
    readonly definitionVersion: string | null | undefined;
    readonly id: string;
    readonly listName: string | null | undefined;
    readonly modifiedAt: any;
    readonly startWhen: StartWhen;
    readonly status: Status;
  }>;
  readonly pageInfo: {
    readonly " $fragmentSpreads": FragmentRefs<"listPaginationQueryFragment">;
  };
  readonly " $fragmentType": "processDefinitionsArchivedQueryFragment";
};
export type processDefinitionsArchivedQueryFragment$key = {
  readonly " $data"?: processDefinitionsArchivedQueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"processDefinitionsArchivedQueryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "processDefinitionsArchivedQueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProcessDefinition",
      "kind": "LinkedField",
      "name": "content",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitionKey",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitionName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitionVersion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "modifiedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startWhen",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "listName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "listPaginationQueryFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProcessDefinitionPage",
  "abstractKey": null
};

(node as any).hash = "2eb81bd0cfaa1a6b7cd61e2cbbd81ac0";

export default node;
